import { PassTier } from 'data/PassTier'
import { isFreeTier } from 'utils/passTier'
import { AppThunk } from 'redux/store'
import { flatMap } from 'lodash'
import { setDisplayState, PaywallDisplay } from 'redux/slices/paywall'
import { userHasPurchasedTicket } from 'redux/slices/passes'
import { getShow } from 'redux/slices/liveShow'
import { YupConfig, AnyObject } from 'data/Common'
import { setFormDataForValidationSchema, setChosenPassTier } from '.'
import { setFormValues } from '.'
import { createAsyncThunk } from '@reduxjs/toolkit'
import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga'

export const choosePassTier = (passTier: PassTier): AppThunk => async dispatch => {
    const formData: YupConfig[] = flatMap(passTier.formGroups, group =>
        group.fields.map(field => ({
            id: field._id,
            validationType: field.validationType,
            validations: field.validations,
        })),
    )

    dispatch(setFormDataForValidationSchema(formData))
    dispatch(setChosenPassTier(passTier))
}

export const submitPassTierSelection = (passTier: PassTier, data: AnyObject): AppThunk => async dispatch => {
    const newState = isFreeTier(passTier) ? PaywallDisplay.FREE_TIER_EMAIL : PaywallDisplay.PAYMENT

    ReactPixel.track('InitiateCheckout')
    ReactGA.event({ category: 'Pass Purchase', action: 'Button Click', label: 'Initiate Checkout' })
    dispatch(setFormValues(data))
    dispatch(setDisplayState(newState))
}

export const initiatePassTiers = createAsyncThunk(
    'passTier/initiatePassTiers',
    async (_, { dispatch, getState }: any) => {
        const show = getShow(getState())!

        const formData = flatMap(show.passTiers, pTier => flatMap(pTier.formGroups, group => group.fields))
        const formValues = formData.reduce((values, obj) => {
            values[obj._id] = ''
            return values
        }, {})
        dispatch(setFormValues(formValues))
    },
    {
        condition: (_, { getState }: any) => {
            return !userHasPurchasedTicket(getState())
        },
    },
)
